import type { ColumnFilters } from './filters';
import { COLUMN_LABELS, DEFAULT_COLUMN_ORDER } from 'src/routes/widgets/LocatesV2Widget/columns';
import type { LocatesV2ColumnId } from 'src/routes/widgets/LocatesV2Widget/columns';

export interface ActiveColumnFilter {
    columnId: LocatesV2ColumnId;
    label: string;
}

export function getActiveColumnFilters(filters: ColumnFilters): ActiveColumnFilter[] {
    return DEFAULT_COLUMN_ORDER.flatMap((columnId) => {
        const value = filters[columnId]?.trim();
        return value ? [{ columnId, label: `${COLUMN_LABELS[columnId]}: ${value}` }] : [];
    });
}
